export default "__VITE_ASSET__CpUF3VmL__"